export const rules = {
  'RADIO:ui': {
    enable: ['STATE:IN:BET'],
    disable: [
      'STATE:OUT:BET',
      'INIT:FREESPINS',
    ],
  },
  'BUTTON:nextbet': {
    enable: [
      'STATE:IN:BET',
      'RADIO:ui',
    ],
    disable: [
      'INIT:FREESPINS',
      'STATE:OUT:BET',
      'RADIO:ui|automenu',
      'STATE:OUT:FS-START',
    ],
  },
  'BUTTON:nextauto': {
    enable: ['RADIO:ui|automenu'],
    disable: [
      'STATE:IN:BET',
      'RADIO:ui',
    ],
  },
  'BUTTON:prevauto': {
    enable: ['RADIO:ui|automenu'],
    disable: [
      'STATE:IN:BET',
      'RADIO:ui',
    ],
  },
  'BUTTON:prevbet': {
    enable: [
      'STATE:IN:BET',
      'RADIO:ui',
    ],
    disable: [
      'STATE:OUT:BET',
      'INIT:FREESPINS',
      'RADIO:ui|automenu',
      'STATE:OUT:FS-START',
    ],
  },
}
